// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"37ffb11f","453":"bf0f59d9"}[chunkId] + ".chunk.js";
};